module.exports = __webpack_public_path__ + "static/media/open.b0ca731b.png";